import React, { useCallback, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import * as PermissionsConstants from "../../const/constants.js";
import { useHistory } from 'react-router-dom';
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar,
  Item,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter
  
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';

import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";

import "jspdf-autotable";
import "../css/omstyle.css";
import { RenderButtonForGrid, getUrlForButton } from '../services/OMService';
const OMTransactionHistoryGrid = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  var permissions = props.ReceiptReducer.rolePermissions;
  const history = useHistory();
  const rowId = useRef(null);
  const allowedPageSizes = [10, 20, 100, 300];
  const gridKey = "5a4a2946-680f-4925-9af3-bbde3f8aad2d";
  const [currentLayout, setCurrentLayout]= useState("Default");
  const [isDisabled, setIsDisabled] = useState(true);

  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length > 0) {
      rowId.current = selectedRowsData[0].rowid;
    } else {
      rowId.current = '';
    }
      if (canUpdateQuote && props.selectedTab === tabQuote) {
        setIsDisabled(!isDisabled);
      }
      else if (canUpdateOrder && props.selectedTab === tabOrder) {
        setIsDisabled(!isDisabled);
      }
      if ( props.selectedTab === tabHistory) {
        setIsDisabled(!isDisabled);
      }
  };
  const canUpdateQuote = permissions.OM.includes(PermissionsConstants.OMUpdateQuoteeRole);
  const canUpdateOrder = permissions.OM.includes(PermissionsConstants.OMUpdateOrderRole);
  const canReadQuote = permissions.OM.includes(PermissionsConstants.OMReadQuoteRole);
  const canReadOrder = permissions.OM.includes(PermissionsConstants.OMReadOrderRole);
  const tabQuote = "Quote";
  const tabOrder = "Order";
  const tabHistory = "History";
  const handelEditClick = () => {
    const buttonUrl = getUrlForButton(props.selectedTab, permissions, "edit")+"?id="+ rowId.current;
    history.push(buttonUrl);
  };
  const handelViewClick = () => {
    const buttonUrl = getUrlForButton(props.selectedTab, permissions, "view")+"?id="+ rowId.current;
    history.push(buttonUrl);
  };

  return (
    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
      ref={dataGrid}
      allowColumnReordering={true}
      allowColumnResizing={true}
      dataSource={props.data}
      showBorders={true}
      hoverStateEnabled={true}
      onSelectionChanged={(e) => onSelectionChanged(e)}
      className="search-page-grid"
        remoteOperations={true}
        searchEnabled={true}
        columnAutoWidth={true}
      >
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <ColumnHeaderFilter />
        <Export enabled={true} allowExportSelectedData={true} />
        <Selection mode="multiple" />
        <Sorting visible={true} mode="multiple" />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter enabled={true} visible={false} />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Scrolling rowRenderingMode="virtual" />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <Scrolling mode="virtual" />
        <Column dataField="transactionnumber" caption="Transaction #"></Column>
        <Column
          dataField="transactiondate"
          dataType="date"
          caption='Trans Date'
        ></Column>
        <Column
          dataField="shippingdate"
          dataType="date"
          caption='Shipping Date'
        ></Column>
        <Column dataField="ponumber" caption='P.O. No'></Column>
        <Column  dataField="status" caption='Status'></Column>
        <Column dataField="stage" caption='Stage'></Column>

        <Column
          dataField="shipvia"
          caption="Shipvia"
          visible={false}
        ></Column>

        <Column
          dataField="shipvianame"
          caption="Shipvia Name"
          visible={false}
        ></Column>

        <Column
          dataField="shipto"
          caption="Shipto"
          visible={false}
        ></Column>

        <Column
          dataField="shiptoname"
          caption="Shipto Name"
          visible={false}
        ></Column>

        <Column
          dataField="shipToAddress1"
          caption="Shipto Addr1"
          visible={false}
        ></Column>
        <Column
          dataField="shipToAddress2"
          caption="Shipto Addr2"
          visible={false}
        ></Column>
        <Column
          dataField="shipToZip"
          caption="Shipto Zip"
          visible={false}
        ></Column>
        <Column
          dataField="shipToState"
          caption="Shipto State"
          visible={false}
        ></Column>
        <Column
          dataField="shipToAddressMemo"
          caption="Shipto Addr Memo"
          visible={false}
        ></Column>
        <Column dataField="comment" caption='Description' visible={false}></Column>


        <Column
          dataField="userdefinedcode1"
          caption='Code 1'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode2"
          caption='Code 2'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode3"
          caption='Code 3'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode4"
          caption='Code 4'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode5"
          caption='Code 5'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode6"
          caption='Code 6'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode7"
          caption='Code 7'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode8"
          caption='Code 8'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode9"
          caption='Code 9'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedcode10"
          caption='Code 10'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference1"
          caption='Reference 1'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference2"
          caption='Reference 2'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference3"
          caption='Reference 3'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference4"
          caption='Reference 4'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference5"
          caption='Reference 5'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference6"
          caption='Reference 6'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference7"
          caption='Reference 7'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference8"
          caption='Reference 8'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference9"
          caption='Reference 9'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedreference10"
          caption='Reference 10'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate1"
          caption='Date 1'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate2"
          caption='Date 2'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate3"
          caption='Date 3'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate4"
          caption='Date 4'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate5"
          caption='Date 5'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate6"
          caption='Date 6'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate7"
          caption='Date 7'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate8"
          caption='Date 8'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate9"
          caption='Date 9'
          visible={false}
        ></Column>
        <Column
          dataField="userdefineddate10"
          caption='Date 10'
          visible={false}
        ></Column>

        <Column
          dataField="userdefinedquantity1"
          caption='Quantity 1'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity2"
          caption='Quantity 2'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity3"
          caption='Quantity 3'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity4"
          caption='Quantity 4'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity5"
          caption='Quantity 5'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity6"
          caption='Quantity 6'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity7"
          caption='Quantity 7'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity8"
          caption='Quantity 8'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity9"
          caption='Quantity 9'
          visible={false}
        ></Column>
        <Column
          dataField="userdefinedquantity10"
          caption='Quantity 10'
          visible={false}
        ></Column>
        <Toolbar>
        <Item  location="before">
            {(props.selectedTab === tabHistory) ? (
              <Button  disabled={isDisabled}  onClick={handelViewClick} text="View" type="default"/>
            ) : (<Button  disabled={true}  text="View" type="default"/>)}
          </Item>
          <Item location="after">
                  <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />

        </Toolbar>
      </DataGrid>
  );

};
function mapStateToProps(state) {
  return {
    oidc: state.oidc,
    ReceiptReducer: state.ReceiptReducer,
  };
}
export default connect(mapStateToProps)(OMTransactionHistoryGrid);